<template>
	
	<div>
		
		<legend class="content-area__element-title">Filters</legend>
		
		<div style="margin-bottom: 20px;">
			
			<div class="card card--blue card--shadow card--no-padding card--no-input-border">
				<el-row>
					<el-col :span="4">
						<el-select v-model="filters.client" no-data-text="No clients" placeholder="Select Client" :disabled="preselectClient !== null" @change="onChangeClient" style="width: 100%;" clearable>
							<el-option v-for="item in $store.state.clients" :value="item.id" :label="item.name" :key="item.id">{{ item.name }}</el-option>
						</el-select>
					</el-col>
					<el-col :span="4">
						<el-select v-model="filters.project" no-data-text="No projects" placeholder="Select Project" :disabled="preselectProject !== null" @change="onChangeProject" style="width: 100%;" clearable>
							<el-option v-for="item in projects" :value="item.id" :label="item.name" :key="item.id">{{ item.name }}</el-option>
						</el-select>
					</el-col>
					<el-col :span="4">
						<el-select v-model="filters.ticket" no-data-text="No tickets" placeholder="Select Task" style="width: 100%;" clearable>
							<el-option v-for="item in tickets" :value="item.id" :label="item.name" :key="item.id">{{ item.name }}</el-option>
						</el-select>
					</el-col>
					<el-col :span="6">
						<el-date-picker v-model="filters.daterange" type="daterange" start-placeholder="Start date" end-placeholder="End date" clearable style="width: 100%;"/>
					</el-col>
					<el-col :span="6">
						<el-input v-model="filters.keywords" placeholder="Keywords..." prefix-icon="el-icon-search" clearable/>
					</el-col>
				</el-row>
			</div>
			
			<el-checkbox v-model="filters.rnd" :true-label="1" :false-label="0">Research & Development</el-checkbox>
			
		</div>
		
		<legend class="content-area__element-title">
			Entries
			<el-tag type="info">{{ $store.getters.timebookEntries.length }}</el-tag>
			<el-tag v-if="totalTime" type="info"><strong>Total time:</strong> {{ totalTime | timebookSummary }}</el-tag>
			<download-excel v-if="totalTime" class="el-tag el-tag--export" type="csv" :data="$store.getters.timebookEntries">Export CSV</download-excel>
		</legend>
		
		<div class="card card--border card--no-padding">
			
			<el-table v-loading="loadingTimebook" empty-text="There are no entries in the time book." :data="$store.getters.timebookEntries">
				<el-table-column type="expand">
					<template slot-scope="scope">
						<p v-if="scope.row.manual" class="more-info"><span>Timestamp:</span>{{ scope.row.date_formatted_2 }} - {{ scope.row.date_formatted_1 }}</p>
						<p v-else class="more-info"><span>Timestamp:</span>{{ scope.row.date_formatted_1 }} - {{ scope.row.date_formatted_2 }}</p>
						<p v-if="scope.row.category" class="more-info"><span>Category:</span>{{ scope.row.category }}</p>
						<p v-else class="more-info"><span>Category:</span><span v-html="isNA(scope.row.ticket, 'type')"></span></p>
					</template>
				</el-table-column>
				<el-table-column prop="user_name" label="Person"></el-table-column>
				<el-table-column prop="duration_formatted" label="Time Taken"></el-table-column>
				<el-table-column prop="description" label="Description"></el-table-column>
				<el-table-column label="Client">
					<template slot-scope="scope">
						<p v-if="!scope.row.client" v-html="isNA()"></p>
						<router-link v-if="scope.row.client" :to="{ name: 'clients/client', params: { clientSlug: scope.row.client.slug }}">{{ scope.row.client.name }}</router-link>
					</template>
				</el-table-column>
				<el-table-column label="Project">
					<template slot-scope="scope">
						<p v-if="!scope.row.project" v-html="isNA()"></p>
						<router-link v-if="scope.row.project" :to="{ name: 'projects/project', params: { projectSlug: scope.row.project.slug }}">{{ scope.row.project.name }}</router-link>
					</template>
				</el-table-column>
				<el-table-column label="Task">
					<template slot-scope="scope">
						<p v-if="!scope.row.ticket" v-html="isNA()"></p>
						<router-link v-if="scope.row.ticket" :to="{ name: 'projects/project/ticket', params: { projectSlug: scope.row.project.slug, ticketId: scope.row.ticket.public_id }}">{{ scope.row.ticket.name }}</router-link>
					</template>
				</el-table-column>
			</el-table>
			
		</div>
		
	</div>
	
</template>

<script>
	
	import _ from "lodash";
	
	const days = 7;
	const dateOffset = (24 * 60 * 60 * 1000) * days;
	
	const start = new Date();
	const end = new Date();
	
	start.setTime(start.getTime() - dateOffset);
	
	export default {
		
		name: "TimeBookList",
		
		props: {
			preselectClient: { default: null },
			preselectProject: { default: null },
			preselectTicket: { default: null },
			preselectDaterange: { default: null },
		},
		
		data() {
			
			return {
				
				filters: {
					client: null,
					project: null,
					ticket: null,
					daterange: [start, end],
					keywords: "",
					rnd: 0,
				},
				
				projects: [],
				
				tickets: [],
				
				loadingTimebook: true,
				
			}
			
		},
		
		computed: {
			
			totalTime: function() {
				if (this.$store.getters.timebookEntries.length) {
					return this.$store.getters.timebookEntries.map(a => a.duration).reduce((accumulator, currentValue) => {
						return accumulator + currentValue;
					});
				}
				return false;
			},
			
		},
		
		mounted() {
			
			// Watch for state changes.
			
			this.$store.watch(
				(state) => { return this.$store.state.theTime },
				(newValue, oldValue) => {
					this.refresh();
				},
			);
			
			// Create refresh function.
			
			this.refresh = _.debounce(() => {
				
				this.loadingTimebook = true;
				
				this.axios.get("timebook", { params: this.filters }).then((r) => {
					
					this.loadingTimebook = false;
					
					this.$store.commit("setTimebookEntries", r.data);
					
					this.$emit("on-refresh", this.$store.getters.timebookEntries);
					
				}).catch((e) => {
					
				});
				
			}, 1000);
			
			// Preselect client?
			
			if (this.preselectClient) {
				this.filters.client = this.preselectClient;
				this.onChangeClient(this.preselectClient);
			}
			
			// Preselect daterange?
			
			if (this.preselectDaterange) {
				this.filters.daterange = this.preselectDaterange;
			}
			
			// Refresh the list.
			
			this.refresh();
			
		},
		
		watch: {
			
			filters: {
				deep: true,
				handler(value) {
					this.loadingTimebook = true;
					this.refresh();
				},
			}
			
		},
		
		methods: {
			
			onChangeClient(id) {
				
				// Reset projects and tickets.
				
				this.filters.project = null;
				this.filters.ticket = null;
				
				this.projects = [];
				this.tickets = [];
				
				// Preselect project?
				
				if (this.preselectProject) {
					this.filters.project = this.preselectProject;
					this.onChangeProject(this.preselectProject);
				}
				
				// Find this client's projects.
				
				this.$store.state.clients.map((data, i) => {
					if (data.id == id) {
						this.projects = data.projects;
					}
				});
				
			},
			
			onChangeProject(id) {
				
				// Reset tickets.
				
				this.filters.ticket = null;
				
				this.tickets = [];
				
				// Get tickets for this project.
				
				this.axios.get(`projects/${id}`).then((r) => {
					this.tickets = r.data[0].tickets;
				});
				
			},
			
			isNA(data, key, routerLink) {
				if (data && data[key]) {
					let value = data[key];
					if (routerLink) {
						return "<router-link :to='{ name: 'projects/project', params: { projectSlug: 'road-awareness-program' }}'>" + value + "</router-link>";
					}
					return value;
				}
				return "<span style='opacity: 0.5;'>N/A</span>";
			}
			
		}
		
	}
	
</script>

<style scoped>
	
	
	
</style>


// WEBPACK FOOTER //
// src/components/TimeBook/List.vue